import React from "react";
import { Helmet } from "react-helmet";
import { SearchBar } from "views/components/SearchBar";
import ToolGrid from "views/components/ToolGrid";
import { CategoryTags } from "views/components/CategoryTags";
import CategoryStats from "views/components/CategoryStats";
import { Layout } from "views/common/Layout";

export const Landing = () => {
    return (
        <Layout>
            <Helmet>
                <title>
                    Find the Perfect Product for Your Needs | Launch Hero FYI
                </title>
                <meta
                    name="description"
                    content="Search through our curated collection of products and find exactly what you're looking for. Discover the best tools and solutions for your needs."
                />
                <meta
                    name="keywords"
                    content="product search, tool finder, AI tools, software tools, product discovery, tool directory"
                />
                <meta
                    property="og:title"
                    content="Find the Perfect Product for Your Needs | Launch Hero FYI"
                />
                <meta
                    property="og:description"
                    content="Search through our curated collection of products and find exactly what you're looking for. Discover the best tools and solutions for your needs."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={window.location.href} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:title"
                    content="Find the Perfect Product for Your Needs | Launch Hero FYI"
                />
                <meta
                    name="twitter:description"
                    content="Search through our curated collection of products and find exactly what you're looking for. Discover the best tools and solutions for your needs."
                />
            </Helmet>
            <div className="flex flex-col min-h-screen bg-background">
                {/* Hero Banner Section */}
                <div className="relative bg-gradient-to-b from-blue-50 to-white dark:from-gray-900 dark:to-gray-800">
                    <div className="absolute inset-0 bg-grid-pattern opacity-5" />
                    <div className="relative">
                        <div className="container mx-auto px-4 py-12 sm:py-16 lg:py-20 text-center max-w-7xl">
                            <h1 className="text-4xl font-bold tracking-tight sm:text-6xl bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-gray-600 dark:from-white dark:to-gray-300">
                                Find the perfect product for your needs
                            </h1>
                            <p className="mt-4 text-lg leading-8 text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
                                Search through our curated collection of
                                products and find exactly what you're looking
                                for.
                            </p>
                            <div className="mt-8 max-w-xl mx-auto">
                                <SearchBar />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main Content */}
                <div className="flex-1 flex flex-col items-center">
                    {/* Category Tags Section */}
                    <div className="w-full bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700">
                        <div className="container mx-auto px-4 py-4 max-w-7xl">
                            <CategoryTags />
                        </div>
                    </div>

                    {/* Latest Tools Section */}
                    <div className="w-full">
                        <div className="container mx-auto px-4 max-w-7xl">
                            <ToolGrid />
                        </div>
                    </div>

                    {/* Top Categories Section */}
                    <div className="w-full bg-gray-50 dark:bg-gray-900">
                        <div className="container mx-auto px-4 py-4 max-w-7xl">
                            <CategoryStats />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};
